export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART";
export const SET_CART_ITEMS = "SET_CART_ITEMS";
export const CLEAR_CART = "CLEAR_CART";